import React from "react";

import { ButtonStyle } from "./Atoms.Style";

const Button = ({ children, fill, large, onclick }) => {
	return (
        <ButtonStyle fill={fill} large={large} onClick={onclick}>
	 {children} 
        </ButtonStyle>
	);
};

export default Button;
